import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

// Static Privacy Policy — placeholder so the footer "Privacy" link works. Swap in
// the lawyer-reviewed copy when ready.

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-12" data-testid="page-privacy">
      <div className="flex items-center gap-2 mb-2">
        <ShieldCheck className="text-[#2D5A27]" size={22} />
        <div className="text-[10px] uppercase tracking-widest font-black text-stone-500">Legal</div>
      </div>
      <h1 className="heading text-3xl md:text-4xl font-extrabold text-stone-900">Privacy Policy</h1>
      <div className="text-sm text-stone-500 mt-1">Last updated: February 2026</div>

      <div className="mt-8 space-y-6 text-stone-700 leading-relaxed">
        <section>
          <h2 className="heading font-bold text-lg text-stone-900 mb-1">What we collect</h2>
          <ul className="list-disc ml-6 space-y-1">
            <li>Account info you give us — name, phone, email, KYC where required.</li>
            <li>Location — only after your explicit permission, to show nearby services.</li>
            <li>Usage data — pages visited, listings viewed, ads clicked (used to power the Ad Analytics dashboard).</li>
            <li>Payment info — processed by our payment providers; we never store card numbers.</li>
          </ul>
        </section>
        <section>
          <h2 className="heading font-bold text-lg text-stone-900 mb-1">How we use it</h2>
          <p>To run the marketplace: match you with local providers, verify listings, process payments, send you booking/delivery updates, and improve the product. We do not sell your personal data.</p>
        </section>
        <section>
          <h2 className="heading font-bold text-lg text-stone-900 mb-1">Your rights</h2>
          <p>You can view, correct or delete your data any time from <Link to="/account" className="text-[#E05E36] font-semibold">Account settings</Link>, or write to us at <a className="text-[#E05E36] font-semibold" href="mailto:privacy@find2near.com">privacy@find2near.com</a>.</p>
        </section>
        <section>
          <h2 className="heading font-bold text-lg text-stone-900 mb-1">Cookies</h2>
          <p>We use a small number of essential cookies to keep you logged in and remember your city. No third-party ad tracking cookies.</p>
        </section>
      </div>
    </div>
  );
}
